module.exports = __webpack_public_path__ + "static/media/image-9.866e00fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-nuevo/image-9.jpg
// module id = 261
// module chunks = 0